<template>
  <div>
    <v-form ref="form" lazy-validation>
      <div class="service commonCode">
        <!-- <h3 class="mb-2">공통코드 관리</h3> -->
        <div class="filter-box filter-box--row">
          <ul class="filter-list02">
            <li>
              <h4>공통코드명</h4>
              <div class="wrapperEnd">
                <v-text-field outlined dense placeholder="" v-model="input.gubun" @keyup.enter="search"></v-text-field>
              </div>
            </li>
          </ul>
          <div class="btn-box">
            <v-card-actions>
              <v-btn depressed class="btn-reset" @click="reset">초기화</v-btn>
            </v-card-actions>
            <v-card-actions>
              <v-btn depressed class="btn-search" @click="search">검색</v-btn>
            </v-card-actions>
          </div>
        </div>
        <!-- <div class="filter">
          <v-row class="row px-4 py-3 sch wrapperSpace" style="height: 105px">
            <v-col cols="12" sm="3">
              <h4>공통코드명</h4>
              <div class="wrapperEnd">
                <v-text-field
                  outlined
                  dense
                  placeholder="공통코드명을 입력해 주세요."
                  v-model="input.gubun"
                ></v-text-field>
              </div>
            </v-col>
            <div class="wrapperTop pt-7">
              <v-card-actions>
                <v-btn depressed outlined @click="reset">초기화</v-btn>
              </v-card-actions>
              <v-card-actions>
                <v-btn depressed color="primary" @click="search">검색</v-btn>
              </v-card-actions>
            </div>
          </v-row>
        </div> -->
        <!-- <h3 class="mt-4 mb-2">목록</h3> -->
        <div class="wrapperEnd mb-2">
          <v-btn depressed class="btn-add" @click="openAddDialog">공통코드 추가</v-btn>
        </div>
        <RealGrid :domName="grid" ref="grid" :settings="settings" @changePage="loadData" @dbClick="dbClick" />
      </div>
    </v-form>

    <v-dialog v-model="addDialog" max-width="480px" persistent>
      <v-card class="commonCodeAdd">
        <v-card-title>공통코드 추가</v-card-title>
        <v-card-text>
          <h4>공통코드명</h4>
          <v-text-field outlined dense placeholder="예) 원산지제한" v-model="addParam.gubun" maxlength="20"></v-text-field>
          <h4>코드</h4>
          <v-text-field outlined dense placeholder="예) OR (3자 이내)" v-model="addParam.code" maxlength="3"></v-text-field>
          <h4>첫 항목 값</h4>
          <v-text-field outlined dense placeholder="예) N1" v-model="addParam.val"></v-text-field>
          <h4>첫 항목 설명</h4>
          <v-text-field outlined dense placeholder="화면에 보이는 이름. 예) 중국" v-model="addParam.description"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn depressed class="btn-reset" @click="closeAddDialog">취소</v-btn>
          <v-btn depressed class="btn-save ml-1" @click="saveNewCode">저장</v-btn>
          <div class="commonCodeAdd__right-space"></div>
        </v-card-actions>
        <!-- 버튼이 모달 모서리에 붙어 잘리는 것을 막는 여백 -->
        <div class="commonCodeAdd__bottom-space"></div>
      </v-card>
    </v-dialog>

    <SetPopup ref="confirm" />
  </div>
</template>
<script>
import { columns, fields, rows } from '@/assets/grid/codeMgn';
import { getCodeAll, insertCode } from 'api/common';
import { mapMutations, mapState } from 'vuex';
import RealGrid from '@/components/RealGrid.vue';
import SetPopup from '@/components/SetPopup.vue';
import validSet from '@/assets/valid';
import { errorText } from '@/assets/apiError';
import _ from 'lodash';
export default {
  data() {
    return {
      input: {
        gubun: '',
        pageSize: 100000,
      },
      settings: {
        columns,
        fields,
        rows,
        height: 650,
        hideCheckBar: true,
      },
      grid: 'codeMgn',
      validSet,
      currentPage: 1,
      saveParam: {},
      addDialog: false,
      addParam: {
        gubun: '',
        code: '',
        val: '',
        description: '',
      },
      isSaving: false,
    };
  },
  computed: {
    ...mapState('select', ['workType', 'roleType']),
  },
  watch: {
    param: {
      deep: true,
      handler: function () {
        this.currentPage = 1;
      },
    },
  },
  mounted() {
    this.SET_POPUP({
      title: '알림',
      // height: 150,
      width: 300,
      customApprove: true,
    });
    this.loadData();
  },
  methods: {
    ...mapMutations('popup', ['SET_POPUP', 'SET_POPUP_TEXT']),
    reset() {
      this.input = {
        gubun: '',
        pageSize: 100000,
      };
    },
    loadData(v) {
      this.search(v);
    },
    valid() {
      return this.$refs.form.validate();
    },
    search(v) {
      if (this.valid()) {
        if (_.isNumber(v)) {
          this.currentPage = v;
        }
        getCodeAll({
          ...this.input,
          currentPage: this.currentPage,
        }).then(res => {
          const response = res.data;
          const items = response.data.items;
          const page = response.data.params;
          this.$refs.grid.loadData(items);
          this.$refs.grid.setPage(page);
        });
      }
    },
    openAddDialog() {
      this.addParam = { gubun: '', code: '', val: '', description: '' };
      this.addDialog = true;
    },
    closeAddDialog() {
      this.addDialog = false;
    },
    // 공통코드는 항목 행이 있어야 존재한다. 그래서 그룹을 만들 때 첫 항목까지 같이 넣는다.
    async saveNewCode() {
      if (this.isSaving) return;

      if (!this.addParam.gubun) {
        this.openPopup('공통코드명을 입력해 주세요.');
        return;
      }
      if (!this.addParam.code) {
        this.openPopup('코드를 입력해 주세요.');
        return;
      }

      this.isSaving = true;
      try {
        await insertCode({ ...this.addParam });
        this.addDialog = false;
        this.search();
        this.openPopup('등록되었습니다. 항목은 코드 상세에서 추가할 수 있습니다.');
      } catch (err) {
        this.openPopup(errorText(err, '등록에 실패했습니다.'));
      } finally {
        this.isSaving = false;
      }
    },
    openPopup(text, closable = false, cb) {
      this.SET_POPUP({
        title: '알림',
        width: 300,
        closable: closable,
        text: text,
      });
      this.$refs.confirm.openPopup(cb);
    },
    dbClick(data) {
      this.$emit('dbClick', data);
    },
  },
  components: {
    RealGrid,
    SetPopup,
  },
};
</script>
<style lang="scss">
.commonCode {
  .v-text-field__details {
    display: none;
  }
}
/* Vuetify 의 .v-card__actions 패딩을 단일클래스로 못 이겨 버튼이 모서리에 잘림 →
   카드 안 스페이서 div 로 오른쪽·아래 여백을 확보 */
.commonCodeAdd__right-space {
  width: 20px;
  flex: 0 0 auto;
}
.commonCodeAdd__bottom-space {
  height: 24px;
}
</style>
